const microDepositValidationStatus = {
  PRE_VALIDATED_ON_BANK: 'PRE_VALIDADO_NO_BANCO',
  VALIDATED: 'VALIDADO'
};

module.exports = microDepositValidationStatus;
